
import { defineComponent, ref, watch, computed, onMounted } from "vue";
import {
  loadDemoTokenMetaWithListener,
  convertTokenMetaToOpensea
} from "@/api/token";
import {
  FirestoreDocument,
  Display,
  OpenseaToken,
  TokenMeta
} from "@/types/types";
import Loading from "vue-loading-overlay";
import QrcodeVue from "qrcode.vue";
import { getDisplayByDisplayIDWithListener } from "@/api/display";

export default defineComponent({
  props: {
    display_id: String
  },
  components: {
    QrcodeVue,
    Loading
  },
  setup() {
    const display = ref<FirestoreDocument<Display> | null>();
    const token = ref<OpenseaToken | null>();
    const token_meta = ref<FirestoreDocument<TokenMeta> | null>();
    const loading = ref(false);
    const display_id = ref(window.localStorage.getItem("nft_display_id"));
    const show_text = ref(false);

    onMounted(() => {
      display_id.value = window.localStorage.getItem("nft_display_id");
      //show_text.value = true
      /* if (display_id.value) {
        show_text.value = true;
      } */
    });

    const initDisplay = async (d: FirestoreDocument<Display>) => {
      show_text.value = false;
      await new Promise(r => setTimeout(r, 800));

      display.value = d;
      if (d.entity.token_id && d.entity.asset_contract_address) {
        await loadDemoTokenMetaWithListener(d.entity.asset_contract_address, d.entity.token_id, getPlaqueData);
      }
      show_text.value = true;
      loading.value = false;
    };

    const getPlaqueData = async (t: FirestoreDocument<TokenMeta>) => {
      token_meta.value = t
      let token_resp = convertTokenMetaToOpensea(t);
      token.value = token_resp;
    };

    const dark_mode = computed(() => {
      return display?.value?.entity.plaque_dark_mode;
    });

    const top_bid = computed((): string => {
      if(token_meta.value?.entity.top_bid) {
        return `Top bid: ${token_meta.value.entity.top_bid}`
      }

      return ""
      /* const orders = token?.value?.orders;
      if (orders == null || orders?.length == 0) {
        return "";
      }
      let highest_order = orders[0];
      orders.forEach(o => {
        if (o.base_price > highest_order.base_price) {
          highest_order = o;
        }
      });
      //highest_order = orders[orders.length - 1];
      const bid =
        highest_order.base_price /
        Math.pow(10, highest_order.payment_token_contract.decimals);

      return `Top bid: ${bid.toFixed(3)} ${
        highest_order.payment_token_contract.symbol
      }`; */
    });

    watch(
      () => display_id.value,
      async () => {
        loading.value = true;
        if (display_id.value) {
          getDisplayByDisplayIDWithListener(display_id.value, initDisplay);
        } else {
          display.value = null;
          loading.value = false;
        }
      },
      { immediate: true }
    );

    window.addEventListener("storage", () => {
      display_id.value = window.localStorage.getItem("nft_display_id");
      /* show_text.value =
        window.localStorage.getItem("nft_video_loaded") == "true"; */
    });
    return {
      loading,
      token,
      display,
      dark_mode,
      show_text,
      top_bid,
      token_meta
    };
  }
});
